import { createRouter, createWebHistory } from 'vue-router'

import Inicio from "../views/InicioView.vue";
import AtencionAlCliente from "../components/AtencionAlCliente.vue";
import Noticia from "../views/NoticiaView.vue";
import Subir from "../views/SubirView.vue";
import Rutas from "../views/RutasView.vue";
import Politicas from "../views/PoliticasView.vue";
import PoliticasInternas from "../views/PoliticasInternas.vue";
import Corporativo from "../views/CorporativoView.vue";
import PuntosVenta from "../views/PuntosVenta.vue";
import Certificado from "../views/CertificadoView.vue";
import CertificadoSE from "../views/CertificadoSE.vue";
import IdaVuelta from "../views/IdaVuelta.vue";
import PageNotFound from "../views/PageNotFound.vue";
import FormPQR from "../components/FormPQR.vue";
import Prueba from "../views/PruebaView.vue";
import SliderCustom from "../components/SliderCustom.vue";
import Trabaja from "../views/TrabajaView.vue";
import ActualizaDatos from "../views/ActualizaDatos.vue";
import Recaudo from "../views/RecaudoView.vue";
import ConocenosView from "../views/ConocenosView.vue";



const routes = [
  {
    path: "/",
    name: "InicioView",
    component: Inicio,
  },
  {
    path: "/atencion-al-cliente",
    name: "AtencionAlCliente",
    component: AtencionAlCliente,
  },
  {
    path: "/noticias/noticia/:id",
    name: "NoticiaView",
    component: Noticia,
  },
  {
    path: "/subir",
    name: "SubirView",
    component: Subir,
  },
  {
    path: "/pqr",
    name: "FormPQR",
    component: FormPQR,
  },
  {
    path: "/novedades",
    name: "Novedades",
    component: Rutas,
  },
  {
    path: "/politicas",
    name: "PoliticasView",
    component: Politicas,
  },
  {
    path: "/politicas-internas",
    name: "PoliticasInternas",
    component: PoliticasInternas,
  },
  {
    path: "/conocenos",
    name: "ConocenosView",
    component: ConocenosView,
  },
  {
    path: "/corporativo",
    name: "CorporativoView",
    component: Corporativo,
  },
  {
    path: "/puntosdeventa",
    name: "PuntosVenta",
    component: PuntosVenta,
  },
  {
    path: "/certificado-de-viaje",
    name: "CertificadoView",
    component: Certificado,
  },
  {
    path: "/certificado-de-viaje-se",
    name: "CertificadoSE",
    component: CertificadoSE,
  },
  {
    path: "/ida-y-vuelta",
    name: "IdaVuelta",
    component: IdaVuelta,
  },
  {
    path: "/prueba",
    name: "PruebaView",
    component: Prueba,
  },
  {
    path: "/trabaja-con-nosotros",
    name: "TrabajaView",
    component: Trabaja,
  },
  {
    path: "/actualiza-datos",
    name: "ActualizaDatos",
    component: ActualizaDatos,
  },
  {
    path: "/recaudo",
    name: "RecaudoView",
    component: Recaudo,
  },
  {
    path: "/slider",
    name: "SliderCustom",
    component: SliderCustom,
  },

  {
    path: "/:catchAll(.*)",
    component: PageNotFound,
    name: "PageNotFound",
  },

  {
    path: "/about",
    name: "AboutView",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
